export default __webpack_public_path__ + "static/social-730bde364cc36b43821cc85c6a83518a.webp";